export const homepageTranslations = {
  // Header
  nav_home: 'Accueil',
  nav_services: 'Services',
  nav_about: 'À propos',
  nav_quote: 'Soumission',
  service_toiture_title: 'Toiture Lévis',
  phone_number: '418-476-9950',
  cta_quote: 'Soumission gratuite',

  // Hero
  hero_h1: 'Couvreur à Lévis — Soumission gratuite en 2h',
  hero_h1_sub: '',
  hero_subtitle: 'Toiture résidentielle, réfection, réparation. Nos couvreurs partenaires sont certifiés RBQ avec garantie écrite 10 ans.',
  cta_get_quote: 'Obtenir ma soumission',
  cta_urgency: '418-476-9950 — Urgence 7j/7',
  badge_rbq: '',
  badge_google: 'Google',
  badge_guarantee: 'Garantie 10 ans',
  badge_insurance: 'Assurance complète',

  // Empathy
  empathy_h2: "Une toiture qui coule, c'est pas le moment de jouer avec ça.",
  empathy_text: "À Lévis, nos hivers brisent les toitures. Bardeaux soulevés, infiltrations d'eau, glace dans les gouttières — chaque jour d'attente, le problème empire et la facture monte.",

  // Services
  services_h2: 'Nos services de toiture à Lévis',
  services_subtitle: "Du diagnostic à la pose finale, nos partenaires s'occupent de tout.",
  service_refaction_title: 'Réfection complète de toiture',
  service_refaction_desc: 'Bardeau, tôle, membrane — retrait et pose neuve au complet.',
  service_repair_title: "Réparation et infiltration d'eau",
  service_repair_desc: 'Intervention d\'urgence, localisation et scellement des fuites.',
  service_flat_title: 'Toit plat / membrane élastomère',
  service_flat_desc: 'Installation et entretien de membrane élastomère résidentielle.',
  service_metal_title: 'Toiture en tôle et métal',
  service_metal_desc: 'Pose de tôle à nervures, acier galvanisé et aluminium.',
  service_inspection_title: 'Inspection toiture certifiée',
  service_inspection_desc: 'Rapport photo détaillé avec recommandations prioritaires.',
  service_snow_title: 'Déneigement de toit (hiver)',
  service_snow_desc: 'Retrait de la neige et de la glace pour prévenir les dommages.',
  service_link: 'En savoir plus',

  // Why Us
  whyus_h2: 'Pourquoi les gens de Lévis nous choisissent',
  whyus_1_title: 'Soumission en 2h chrono',
  whyus_1_desc: 'On rappelle sous 2h ouvrables, garanti. Pas de attente, pas de stress.',
  whyus_2_title: 'Réseau de couvreurs RBQ certifiés',
  whyus_2_desc: 'Tous nos partenaires sont vérifiés, assurés, accrédités. Pas de sous-contractants inconnus.',
  whyus_3_title: 'Garantie écrite 10 ans',
  whyus_3_desc: 'Main-d\'œuvre et matériaux couverts. On assume nos travaux.',
  whyus_4_title: 'Prix transparent',
  whyus_4_desc: 'Soumission détaillée, signée, finale. Pas de surprises en fin de chantier.',

  // Process
  process_h2: 'Comment ça marche',
  process_step1: 'Vous demandez votre soumission',
  process_step1_desc: 'En ligne ou au téléphone, ça prend 2 minutes.',
  process_step2: 'On inspecte gratuitement votre toiture',
  process_step2_desc: 'Sous 48h, un couvreur évalue l\'état sur place.',
  process_step3: 'Vous recevez une soumission claire',
  process_step3_desc: 'Détaillée, sans jargon, avec photos et options.',
  process_step4: 'Nos partenaires installent',
  process_step4_desc: '1 à 3 jours selon le projet. Propreté garantie.',

  // Zones
  zones_h2: 'Nos partenaires couvrent tout Lévis et ses secteurs',
  zones_list: 'Saint-Romuald • Saint-Nicolas • Charny • Pintendre • Saint-Jean-Chrysostome • Lévis centre • Lauzon • Saint-Étienne-de-Lauzon',

  // Testimonials
  testimonials_h2: 'Ce que les gens de Lévis disent de nos partenaires',
  testimonial_1_text: "L'équipe est arrivée à l'heure, a tout couvert pour protéger mes plantes, et a terminé en une journée. La toiture est impeccable. Ma voisine a déjà demandé leur numéro !",
  testimonial_1_name: 'Marie L.',
  testimonial_1_location: 'Saint-Romuald',
  testimonial_1_project: 'Réfection bardeau d\'asphalte',
  testimonial_2_text: "J'avais une fuite depuis des mois. Un autre couvreur m'avait donné un prix fou. Notre couvreur partenaire a trouvé la vraie source, réparé en demi-journée, et facturé moitié moins. Merci gang !",
  testimonial_2_name: 'Pierre D.',
  testimonial_2_location: 'Charny',
  testimonial_2_project: "Réparation infiltration d'eau",
  testimonial_3_text: "Très professionnels du début à la fin. La soumission était claire, le chantier propre, et le couvreur-chef nous a montré chaque étape. 10 ans de garantie, ça rassure.",
  testimonial_3_name: 'Lise et Robert B.',
  testimonial_3_location: 'Lévis centre',
  testimonial_3_project: 'Réfection complète toiture métal',

  // FAQ
  faq_h2: 'Questions fréquentes',
  faq_q1: 'Combien coûte une nouvelle toiture à Lévis en 2026 ?',
  faq_a1: "Ça dépend de la superficie, des matériaux et de l'accessibilité. En moyenne, compte entre 8 000 $ et 18 000 $ pour une maison unifamiliale standard. La seule façon d'avoir un prix exact, c'est qu'on vienne inspecter. La soumission est gratuite et sans engagement.",
  faq_q2: "Combien de temps dure une toiture en bardeau d'asphalte ?",
  faq_a2: "Un bardeau d'asphalte de qualité bien installé dure entre 15 et 25 ans dans notre climat québécois. L'entretien régulier, le déneigement et la ventilation adéquate peuvent allonger cette durée de plusieurs années.",
  faq_q3: 'Êtes-vous certifiés et assurés ?',
  faq_a3: "Oui, absolument. Nous détenons une licence valide de la Régie du bâtiment du Québec et une assurance responsabilité civile complète. On vous présente les documents sur demande, sans problème.",
  faq_q4: 'Offrez-vous une garantie écrite ?',
  faq_a4: "Oui. Tous nos travaux sont couverts par une garantie écrite de 10 ans sur la main-d'œuvre et les matériaux. C'est signé, daté, et envoyé par courriel. Pas de promesse en l'air.",
  faq_q5: 'Travaillez-vous en hiver ?',
  faq_a5: "On fait des réparations d'urgence et des inspections en hiver, oui. Pour les réfections complètes, on attend généralement le printemps quand les températures le permettent — surtout pour le bardeau d'asphalte qui a besoin de chaleur pour sceller correctement.",
  faq_q6: "Qu'est-ce qui est inclus dans la soumission gratuite ?",
  faq_a6: "L'inspection sur place, un rapport photo détaillé de l'état de votre toiture, une soumission écrite avec prix détaillés par poste, les options de matériaux, et un échéancier de travail. Aucun frais caché, aucune pression.",

  // CTA Final
  cta_h2: 'Prêt à trouver votre couvreur une fois pour toutes ?',
  cta_subtitle: 'Soumission gratuite, sans engagement, livrée en 2h ouvrables. La plateforme qui vous met en relation avec les meilleurs couvreurs de Lévis.',
  cta_button: 'Obtenir ma soumission',
  cta_phone: '418-476-9950',

  // Footer
  footer_brand: 'Couvreur-Lévis.com',
  footer_address: 'Lévis, QC, Canada',
  footer_email: 'contact@couvreur-levis.com',
  footer_services_title: 'Services',
  footer_link_refaction: 'Réfection toiture',
  footer_link_repair: 'Réparation',
  footer_link_flat: 'Toit plat',
  footer_link_metal: 'Tôle et métal',
  footer_link_inspection: 'Inspection',
  footer_links_title: 'Liens',
  footer_link_about: 'À propos',
  footer_link_quote: 'Soumission',
  footer_link_legal: 'Mentions légales',
  footer_link_privacy: 'Politique de confidentialité',
  footer_link_blog: 'Blog',
  footer_copyright: '© 2026 Couvreur-Lévis.com. Tous droits réservés.',
  footer_hours_title: 'Heures',
  footer_hours_week: 'Lun–Ven : 7h00 – 18h00',
  footer_hours_weekend: 'Sam–Dim : 8h00 – 16h00',
};

export default homepageTranslations;